import { render, staticRenderFns } from "./reserve.vue?vue&type=template&id=42818318&scoped=true"
import script from "./reserve.vue?vue&type=script&lang=js"
export * from "./reserve.vue?vue&type=script&lang=js"
import style0 from "./reserve.vue?vue&type=style&index=0&id=42818318&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42818318",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42818318')) {
      api.createRecord('42818318', component.options)
    } else {
      api.reload('42818318', component.options)
    }
    module.hot.accept("./reserve.vue?vue&type=template&id=42818318&scoped=true", function () {
      api.rerender('42818318', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/commodityFacility/detail/reserve.vue"
export default component.exports